export default __webpack_public_path__ + "static/media/no_remark.ee633d99.png";